import * as TK from 'components/PDP/Order/AddToCart/translations/add-to-cart.locale.constants';

export const addToCartCommonLocale = {
  [TK.PRODUCT_ADD_TO_CART]: 'Add To Cart',
  [TK.REDIRECTING]: 'Redirecting...',
  [TK.SUBMITTING]: 'Submitting...',
};
